import { render, staticRenderFns } from "./AResourceDeletion.vue?vue&type=template&id=516d8b2f"
import script from "./AResourceDeletion.vue?vue&type=script&lang=js"
export * from "./AResourceDeletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports